import { tagObj } from "./tags/class-tag.js";
import { generateGoalAttributes } from "../features/goals/goals.js";

/**
 *  Sets up the frontmatter within the `fm` object.
 *
 *  TODO(@aks) would be better if it had no side-effects: it could return frontmatter objects and the caller would assign them instead.
 *
 * fm.regEx
 * fm.categories
 * fm.cateogriesList
 * fm.mood
 * fm.energy
 * fm.clarity
 * fm.tags
 *
 * */
export function setFrontMatterConfigOnWindow(fileArray) {
  for (let lineNum = 0; lineNum < fileArray.length; lineNum++) {
    const line = fileArray[lineNum];
    const lineStart = line.charAt(0);

    // Comments
    if (lineStart.match(window.regExes.comment)) {
      return;
    }

    // Each Line of Frontmatter
    if (lineStart.match(window.regExes.frontMatterLineStart)) {
      // start with @ or $

      // check for date \d\d\d\d\/ - check for normal line \d\d:\d\d
      const taxonomy = line.match(window.regExes.frontMatterTaxonomy);

      // @areas
      if (taxonomy[0].match(window.regExes.frontMatterAreas)) {
        // make list of areas
        const areas = line.match(/\s\w{1,}/g)?.map((area) => {
          return (area = String(area.replace(" ", "")));
        });

        if (areas != null) {
          const areaName = String(taxonomy[0].match(window.regExes.frontMatterAreas)).replace("@", "");
          window.fm.areas[areaName] = areas;
        }
      }

      // $categories
      // we add rhythm tags (side-effect)
      // and we add categories. so, split these into separate functions.
      if (taxonomy[0].match(window.regExes.frontMatterCategories)) {
        const tags = line.match(window.regExes.tagString)?.map((tag) => {
          tag = tag.replace(" ", "");
          const theObj = new tagObj(tag);

          switch (true) {
            case tag.match(window.regExes.moodTag):
              window.fm.mood.push(tag);
              break;
            case tag.match(window.regExes.energyTag):
              window.fm.energy.push(tag);
              break;
            case tag.match(window.regExes.clarityTag):
              window.fm.clarity.push(tag);
              break;
            default: {
              if (!window.fm.tags.includes(theObj)) window.fm.tags.push(theObj);
              return theObj; // for any normal tag
            }
          }

          return tag; // for mood, energy, clarity tags
        });

        const categoryName = String(line.match(window.regExes.frontMatterCategories)).replace("$", "");
        window.fm.categories[categoryName] = tags;
        window.fm.categoriesList.push(categoryName); // make list of moodTags
      }

      if (line.match(window.regExes.frontMatterGoals)) {
        generateGoalAttributes(line);
      }
    } else {
      // [] if tag is not present in any of the category lists, add it to misc
    }
  }
}
